import React from 'react';

const ROWS = [
  {
    others: 'Divide a humanidade em 12 signos',
    ours:   'Calcula o céu do momento em que você nasceu',
  },
  {
    others: 'Repete o mesmo texto para milhões de pessoas',
    ours:   'Gera cada leitura na hora, para o seu mapa específico',
  },
  {
    others: 'Analisa apenas o signo solar',
    ours:   'Lê Sol, Lua, Ascendente, planetas, casas e aspectos',
  },
];

const EYEBROW: React.CSSProperties = {
  fontFamily: 'var(--font-body)',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  color: '#D4AF37',
  margin: 0,
};

export function Differentiators() {
  return (
    <section
      id="diferenciais"
      style={{
        padding: 'clamp(4rem, 8vw, 7rem) 2rem',
        background: 'radial-gradient(ellipse at 50% 0%, #1A0B2E 0%, #0A0416 70%)',
        borderTop: '1px solid rgba(212,175,55,0.1)',
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <p style={{ ...EYEBROW, textAlign: 'center', marginBottom: '1.5rem' }}>
          A diferença
        </p>
        <h2 style={{
          textAlign: 'center',
          margin: '0 0 3.5rem',
          maxWidth: '680px',
          marginLeft: 'auto',
          marginRight: 'auto',
          color: 'rgba(240,246,252,0.95)',
          fontFamily: 'var(--font-display)',
        }}>
          O horóscopo do jornal divide a humanidade em 12 signos.
          A&nbsp;Professya&nbsp;não.
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '1px',
          backgroundColor: 'rgba(212,175,55,0.12)',
          border: '1px solid rgba(212,175,55,0.2)',
          borderRadius: '16px',
          overflow: 'hidden',
        }}>
          {/* Header row */}
          <div style={{ padding: '1rem 1.5rem', backgroundColor: 'rgba(255,255,255,0.04)' }}>
            <p style={{ ...EYEBROW, color: 'rgba(200,220,235,0.4)' }}>O resto</p>
          </div>
          <div style={{ padding: '1rem 1.5rem', backgroundColor: 'rgba(45,27,105,0.6)' }}>
            <p style={EYEBROW}>Professya</p>
          </div>

          {/* Data rows */}
          {ROWS.map((row, i) => (
            <React.Fragment key={i}>
              <div style={{
                padding: '1.25rem 1.5rem',
                backgroundColor: 'rgba(15,6,32,0.8)',
                display: 'flex',
                gap: '0.75rem',
                alignItems: 'flex-start',
              }}>
                <span style={{ color: 'rgba(200,220,235,0.3)', marginTop: '4px', flexShrink: 0, fontSize: '1rem' }}>×</span>
                <p style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 'var(--text-18)',
                  fontWeight: 300,
                  color: 'rgba(200,220,235,0.45)',
                  margin: 0,
                  lineHeight: 1.6,
                  textDecoration: 'line-through',
                  textDecorationColor: 'rgba(200,220,235,0.15)',
                }}>
                  {row.others}
                </p>
              </div>
              <div style={{
                padding: '1.25rem 1.5rem',
                backgroundColor: 'rgba(26,11,46,0.9)',
                display: 'flex',
                gap: '0.75rem',
                alignItems: 'flex-start',
              }}>
                <span style={{ color: '#D4AF37', marginTop: '4px', flexShrink: 0, fontSize: '0.9rem' }}>✦</span>
                <p style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 'var(--text-18)',
                  fontWeight: 300,
                  color: 'rgba(240,246,252,0.92)',
                  margin: 0,
                  lineHeight: 1.6,
                }}>
                  {row.ours}
                </p>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
